import React from "react";

export interface JwtContextValue {
  setJwt: (jwt: string) => void;
  getJwt: () => string;
  getJwtOrNull: () => string | null;
}

export const JwtContext = React.createContext<JwtContextValue>(null!);
